import React from 'react';

const About = () => {
  return (
    <section id="about" aria-label="Perfil">
      <h2 className="text-2xl font-poppins mb-4">Perfil</h2>
      <p>
        Profesional apasionada por crear experiencias web inmersivas. Lidero despliegues responsivos, optimizo flujos de usuario y trabajo con arquitecturas cloud serverless e integración de chatbots e IA.
      </p>
      <ul className="mt-3 list-disc pl-5">
        <li>+2 años experiencia en aplicaciones responsive y serverless.</li>
        <li>Integración de IA (Azure AI, AWS SageMaker) y cumplimiento WCAG 2.1 AA.</li>
      </ul>
    </section>
  );
};

export default About;
